import { render, staticRenderFns } from "./ConversionSettingsCreate.vue?vue&type=template&id=f14ace6e&scoped=true"
import script from "./ConversionSettingsCreate.vue?vue&type=script&lang=ts"
export * from "./ConversionSettingsCreate.vue?vue&type=script&lang=ts"
import style0 from "./ConversionSettingsCreate.vue?vue&type=style&index=0&id=f14ace6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14ace6e",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/conversion/conversion-settings-create.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2Fconversion%2FConversionSettingsCreate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports